define('LimitItemQuantity.Checkout', [
  'LimitItemQuantity.Helper',
  'jQuery',
  'underscore'
], function LimitItemQuantityCheckout(
  Helper,
  jQuery,
  _
) {
  'use strict';

  return {

    getCartLines: function getCartLines(cartComponent) {
      var self = this;
      cartComponent.getLines().then(function getLines(lines) {
        self.cartLines = lines;
      });
    },

    mountToApp: function mountToApp(container) {
      var cartComponent = container.getComponent('Cart');
      var environment = container.getComponent('Environment');
      var enabledForPlaceOrder = environment.getConfig('limitItemQuantity.enabledForPlaceOrder');
      var self = this;
      if (enabledForPlaceOrder) {
        this.getCartLines(cartComponent);

        cartComponent.cancelableOn('beforeSubmit', function beforeAddLine() {
          var promise = jQuery.Deferred();
          var errorMessage;
          var isValid = true;
          var invalidItems;
          _.each(self.cartLines, function eachLine(line) {
            var lineValidation = Helper.validateItem({
              quantityavailable: line.item.extras.quantityavailable,
              isbackorderable: line.item.extras.isbackorderable
            }, line.quantity);
            if (!lineValidation.isValid) {
              isValid = false;
              invalidItems = invalidItems ? invalidItems + ' - ' + line.item.extras.storedisplayname2 : line.item.extras.storedisplayname2;
            }
          });
          if (!isValid && invalidItems) {
            errorMessage = Helper.insufficientAmountPlaceOrder.errorMessage.replace('[ITEMS]', invalidItems);
            throw errorMessage;
          } else {
            promise.resolve();
          }
          return promise;
        });
      }
    }
  };
});
